<template>
  <div id="fh5co-wrapper">
  <div id="fh5co-page">
  <Header></Header>
  <div class="company-container company-container01">
    <div>
      <h2>Legame online</h2>
      <p>関わる全ての人に<br>健康とわくわくを提供する。</p>
      <p>この理念を胸に<br>ご自宅などで本格的な<br>運動方法・わくわくするような<br>コンテンツを提供できるような<br>動画を配信していきます。</p>
    </div>
  </div>
  <div class="company-container company-container02">
    <div>
      <h2>株式会社Follow</h2>
      <p>設立：2019年11月7日</p>
      <p>代表取締役：藤原 安剛</p>
      <p>所在地：063-0811<br>札幌市西区琴似1条5丁目3-22-102</p>
      <p>連絡先：taku-gym@legame-online.com</p>
    </div>
  </div>
  <Footer></Footer>
</div>
</div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'Company',
  components: {
    Header,
    Footer
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.company-container{
  height: 75vw;
  background-size: cover;
  position: relative;
}
  .company-container>div{
    position: absolute;
    background-color: rgba(255, 255, 255, 0.7);
    top: 5vw;
    padding: 30px 40px;
    text-align: center;
  }
  .company-container h2{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 40px;
  }
  .company-container p{
    font-size: 14px;
  }

.company-container01{
  background-image: url(/static/company_back01.jpg);
}
.company-container02{
  background-image: url(/static/company_back02.jpg);
}
  .company-container01>div{
    left: 5vw;
  }
  .company-container02>div{
    right: 5vw;
  }

@media screen and (max-width: 640px) {
  .company-container>div{
    top: 4vw;
    padding: 20px 25px;
  }
  .company-container h2{
    font-size: 14px;
    margin-bottom: 10px;
  }
  .company-container p{
    font-size: 12px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Company.vue